<div mat-dialog-content autoFocus="false">
  <div class="wrapper">
    <!-- Email Preview Pane -->
    <div class="email-preview-pane">
      <!-- Preview Controls -->
      <div class="email-preview-controls">
        <div class="device-previews">
          <button (click)="changePreviewWidth('100%')" color="accent" mat-button>
            <mat-icon>computer</mat-icon>
            Desktop
          </button>
          <button (click)="changePreviewWidth('600px')" color="accent" mat-button>
            <mat-icon>tablet_mac</mat-icon>
            Tablet
          </button>
          <button (click)="changePreviewWidth('320px')" color="accent" mat-button>
            <mat-icon>phone_iphone</mat-icon>
            Mobile
          </button>
        </div>

        <div class="code-previews">
          <button (click)="toggleSourceCode()" color="accent" mat-button>
            <mat-icon>code</mat-icon>
            Html
          </button>
        </div>
      </div>

      <!-- Email Preview and Sourcecode -->
      <div class="email-preview">
        <iframe id="email-preview-iframe" sandbox [srcdoc]="htmlContent | iTrustThisHtml"></iframe>
        <div>
          <textarea id="source-code" readonly>{{ htmlContent }}</textarea>
        </div>
      </div>
    </div>

    <!-- Email Information Pane -->
    <div class="email-info-pane">
      <button mat-icon-button mat-dialog-close class="close-modal" color="accent">
        <mat-icon aria-label="Close">close</mat-icon>
      </button>

      <div class="email-info-container email-info"></div>

      <!-- Secondary Information Tabs -->
      <!-- the @.disabled stops the tab switching animation -->
      <mat-tab-group [@.disabled]="true" [selectedIndex]="selectedTab" (selectedTabChange)="activeTab($event)">
        <!-- Details Tab -->
        <mat-tab label="Details">
          <!-- Email Information Pane -->
          <div class="email-info-container email-info">
            <div class="subject">
              <span class="info-label">Subject</span>
              {{ email.subject }}
            </div>

            <div class="email-to-from">
              <span class="info-label">To</span>
              @for (to of email.to; track to) {
                <div class="email-to-from">
                  <span class="email-name">{{ to.name }}</span>
                  <span class="email-email">({{ to.emailAddress }})</span>
                </div>
              }
            </div>

            <div class="email-info-data email-info-name">
              <span class="info-label">From</span>
              <span class="email-name">{{ email.from.name }}</span>
              <span class="email-email">({{ email.from.emailAddress }})</span>
            </div>
          </div>
        </mat-tab>

        <!-- Events Tab -->
        <mat-tab label="Events">
          @if (events$ | async; as events) {
            <mat-list class="event-list">
              @for (e of events; track e) {
                <mat-list-item>
                  @switch (eventTypeToString(e.eventType)) {
                    @case ('OPENED') {
                      <mat-icon matListItemIcon>drafts</mat-icon>
                    }
                    @case ('DELIVERED') {
                      <mat-icon matListItemIcon>mail</mat-icon>
                    }
                    @case ('PROCESSED') {
                      <mat-icon matListItemIcon>send</mat-icon>
                    }
                    @case ('BOUNCED') {
                      <mat-icon matListItemIcon>trending_down</mat-icon>
                    }
                    @case ('DEFERRED') {
                      <mat-icon matListItemIcon>replay</mat-icon>
                    }
                    @case ('DROPPED') {
                      <mat-icon matListItemIcon>remove_circle_outline</mat-icon>
                    }
                    @default {
                      <mat-icon matListItemIcon>crop_square</mat-icon>
                    }
                  }
                  <h4 class="key" mat-line>
                    {{ eventTypeToString(e.eventType) | titlecase }}
                  </h4>
                  <p mat-line>{{ e.eventTime | date: 'medium' }}</p>
                </mat-list-item>
              }
            </mat-list>
          } @else {
            <mat-list class="event-list">
              <mat-list-item>{{ 'EMAIL.NO_EVENTS' | translate }}</mat-list-item>
            </mat-list>
          }
        </mat-tab>
      </mat-tab-group>
    </div>
  </div>
</div>
